export const maximumTrainCount = 5;

export interface TrainStage {
  readonly number: number;
  readonly id: 'cinder' | 'whiteout' | 'foundry' | 'tempest' | 'blackline';
  readonly label: string;
  readonly subtitle: string;
  readonly body: number;
  readonly accent: number;
  readonly sky: number;
  readonly fog: number;
  readonly ground: number;
  readonly ballast: number;
  readonly rock: number;
  readonly landmark: number;
  readonly weather: number;
  readonly fogNear: number;
  readonly fogFar: number;
}

// All five consists share one authoritative collision manifest. Their visual
// identities deliberately do not: a runner who takes the multiplier should
// recognize the new risk tier before reading a HUD number.
export const trainStages: readonly TrainStage[] = [
  {
    number: 1, id: 'cinder', label: 'CINDER FREIGHT', subtitle: 'SALVAGE LINE',
    body: 0x304a50, accent: 0xff7130, sky: 0x76909b, fog: 0x71858b,
    ground: 0x263137, ballast: 0x42484a, rock: 0x5c4d43, landmark: 0x61463b,
    weather: 0xc98352, fogNear: 80, fogFar: 330,
  },
  {
    number: 2, id: 'whiteout', label: 'WHITEOUT EXPRESS', subtitle: 'CRYO FREIGHT',
    body: 0x526b76, accent: 0x9ff4ff, sky: 0xa8c2ca, fog: 0xb4cbd0,
    ground: 0x879da0, ballast: 0x536166, rock: 0x62767d, landmark: 0x40565b,
    weather: 0xe9ffff, fogNear: 68, fogFar: 270,
  },
  {
    number: 3, id: 'foundry', label: 'FOUNDRY ARMOR', subtitle: 'MOLTEN SECURITY',
    body: 0x432f38, accent: 0xff9b3f, sky: 0x50666a, fog: 0x536467,
    ground: 0x242d2e, ballast: 0x353d3e, rock: 0x4a443d, landmark: 0x6b3329,
    weather: 0xff6f32, fogNear: 72, fogFar: 300,
  },
  {
    number: 4, id: 'tempest', label: 'TEMPEST RUNNER', subtitle: 'STORM TRANSIT',
    body: 0x273b51, accent: 0x6bbcff, sky: 0x344550, fog: 0x3f5059,
    ground: 0x202a30, ballast: 0x303b40, rock: 0x44515a, landmark: 0x313d47,
    weather: 0x9bd9f2, fogNear: 56, fogFar: 245,
  },
  {
    number: 5, id: 'blackline', label: 'BLACKLINE VAULT', subtitle: 'FINAL CONSIST',
    body: 0x171b21, accent: 0xffcf57, sky: 0x282638, fog: 0x353344,
    ground: 0x1c2027, ballast: 0x303039, rock: 0x4c4657, landmark: 0x3a3448,
    weather: 0xd7b4ff, fogNear: 62, fogFar: 270,
  },
] as const;

export function trainStageForNumber(trainNumber: number): TrainStage {
  const safeNumber = Number.isFinite(trainNumber)
    ? Math.max(1, Math.min(maximumTrainCount, Math.trunc(trainNumber)))
    : 1;
  return trainStages[safeNumber-1]!;
}
